import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
} from 'react-admin';
import ProjectTitle from './ProjectTitle';

const ProjectShow = props => (
    <Show title={<ProjectTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <ReferenceField label="Instance" source="instance_id" reference="instances">
                <TextField source="name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

export default ProjectShow;